import { defineStore } from 'pinia'

export const useExternalDataStore = defineStore('externalData', {
    state: () => ({
        selectedType: '',
        validTypes: ['ifly', 'ocp'],
        isSessionActive: false
    }),

    getters: {
        isValidType: (state) => (type) => {
            return state.validTypes.includes(String(type).toLowerCase())
        }
    },

    actions: {
        setType(type) {
            const lowerType = String(type).toLowerCase()
            if (this.validTypes.includes(lowerType)) {
                this.selectedType = lowerType
                this.isSessionActive = true
                sessionStorage.setItem('external_data_selected_type', lowerType)
                sessionStorage.setItem('external_data_session_active', 'true')
            }
        },

        clearType() {
            this.selectedType = ''
            this.isSessionActive = false
            sessionStorage.removeItem('external_data_selected_type')
            sessionStorage.removeItem('external_data_session_active')
        },

        clearSession() {
            this.clearType()
        },

        isValid(type) {
            return this.validTypes.includes(String(type).toLowerCase())
        },

        restoreFromStorage() {
            const stored = sessionStorage.getItem('external_data_selected_type')
            const sessionActive = sessionStorage.getItem('external_data_session_active')

            if (stored && this.isValid(stored) && sessionActive === 'true') {
                this.selectedType = stored
                this.isSessionActive = true
            }
        },

        shouldAutoRedirect() {
            return (
                this.isSessionActive &&
                this.selectedType &&
                this.isValid(this.selectedType)
            );
        },
    },
});
